export default "__VITE_ASSET__BfTed6sc__"